import { render, staticRenderFns } from "./EditVideoForm.vue?vue&type=template&id=2b700460&scoped=true&"
import script from "./EditVideoForm.vue?vue&type=script&lang=js&"
export * from "./EditVideoForm.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditVideoForm.vue?vue&type=style&index=1&id=2b700460&lang=scss&scoped=true&"
import style2 from "./EditVideoForm.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b700460",
  null
  
)

export default component.exports